import { RouteProps } from 'react-router-dom';
import * as routes from '../../../../../../common/constants/routes';
import { TemplateLibraryPanel } from '../../../../templates/panels/TemplateLibraryPanel/TemplateLibraryPanel';
import { TemplateMyPanel } from '../../../../templates/panels/TemplateMyPanel/TemplateMyPanel';
import { TemplateByCodePanel } from '../../../../templates/panels/TemplateByCodePanel/TemplateByCodePanel';

export type SettingsSectionDefinition = {
  id: string;
  path: (chatbotId: number) => string;
  name: string;
  component: RouteProps['component'];
};

export const TEMPLATES_SECTIONS: SettingsSectionDefinition[] = [
  {
    id: 'templates-library',
    name: 'Templates library',
    path: routes.TEMPLATES_LIBRARY,
    component: TemplateLibraryPanel,
  },
  {
    id: 'find-template',
    name: 'Find template by code',
    path: routes.TEMPLATES_FIND,
    component: TemplateByCodePanel,
  },
  {
    id: 'my-templates',
    name: 'My templates',
    path: routes.MY_TEMPLATES,
    component: TemplateMyPanel,
  },
];
